<template>
  <div style="color: #fff" class="rightBar">
    <v-drawer :direction="'left'" :width="'26%'">
      <div class="animated fadeInLeftBig" style="height: 100%; width: 100%">
        <div class="panel margin--bottom">
          <bar-card :bg="'border10'">
            <!-- <div class="closeDraw">
              <el-button icon="el-icon-close"
                         @click="closeClick"></el-button>
            </div> -->
            <div class="cardContentT">
              <jgqs></jgqs>
            </div>

            <div class="cardContentT">
              <jgjc></jgjc>
            </div>
            <div class="cardContentT">
              <div class="cardContentG">
                <v-title :item="srObj">{{ srObj.name }}</v-title>
                <div class="panelContent">
                  <div class="tableTitle flex">
                    <div style="width:40%">市场</div>
                    <div style="width:30%">品种</div>
                    <div style="width:30%">价格(元/公斤)</div>
                  </div>

                  <vue-seamless-scroll
                    :data="marketPriceList"
                    class="tableBody"
                    :class-option="optionHover"
                  >
                    <li
                      v-for="(item, index) in marketPriceList"
                      :key="index"
                      class="flex content1"
                    >
                      <div style="width:40%;">{{ item.name }}</div>
                      <div style="width:30%;">
                        {{ item.breed }}
                      </div>
                      <div style="width:30%;">
                        <span class="money-num">{{ item.price }}</span>
                      </div>
                    </li>
                  </vue-seamless-scroll>
                </div>
              </div>
              <div class="cardContentG">
                <v-title :item="gysjObj">{{ gysjObj.name }}</v-title>
                <div class="panelContent">
                  <div class="tableTitle flex">
                    <div style="width:40%">类型</div>
                    <div style="width:60%">名称</div>
                  </div>
                  <vue-seamless-scroll
                    :data="gysjData"
                    class="tableBody"
                    :class-option="gysjHover"
                  >
                    <li
                      v-for="(item, index) in gysjData"
                      :key="index"
                      class="flex content1"
                      style="padding: 0;"
                      @click="showGysj(item)"
                    >
                      <div style="width:40%;">{{ item.type }}</div>
                      <div
                        style="width:60%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                      >
                        {{ item.name }}
                      </div>
                      <!-- <div style="width:30%;">
                        <span class="money-num">{{ item.price }}</span>
                      </div> -->
                    </li>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>

            <!-- <div class="cardContents">
              <v-title :item="srObj">{{ srObj.name }}</v-title>
              <div class="tab-box flex">
                <div
                  v-for="(item, index) in jgTypeList"
                  :key="index"
                  class="tab-item"
                  :class="{ active: active === index }"
                  @click="changeType(index)"
                >
                  <span>{{ item }}</span>
                </div>
              </div>
              <div class="chart" ref="lineChart" />
            </div> -->
          </bar-card>
        </div>
      </div>
    </v-drawer>
    <el-dialog
      ref="dialog"
      :visible.sync="showdialog"
      :append-to-body="true"
      width="850px"
      :title="gyName"
    >
      <div class="article-box">
        <div class="detail-info" v-html="gyDesc"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { get } from "@/api/index";
import jgjc from "./components/jgjc";
import jgqs from "./components/jgqs";
import { getGysjData } from "@/api/base";
export default {
  components: {
    jgjc,
    jgqs,
  },
  computed: {
    marketPriceList() {
      const data = this.$store.state.schj.datas;
      if (data.marketPriceList) {
        return data.marketPriceList;
      }
      return [];
    },
    optionHover() {
      return {
        step: 0.5, //数值越大速度滚动越快
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        waitTime: 1000, //单步运动停止的时间(默认值1000ms)
      };
    },
    gysjHover() {
      return {
        step: 0.5, //数值越大速度滚动越快
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        waitTime: 1000, //单步运动停止的时间(默认值1000ms)
      };
    },
  },
  data() {
    const year = new Date().getFullYear();
    return {
      srObj: {
        name: "批发市场行情(" + year + ")",
        hasBtn: false,
      },
      gysjObj: {
        name: "海关注册果园与加工厂",
        hasBtn: false,
      },

      tableData: [],
      showdialog: false,
      gyDesc: "",
      gyName: "",
      gysjData: window.gysjData.list,
    };
  },
  methods: {
    // closeClick() {
    //   this.$store.dispatch("drawer/setRightComponent", "rightDrawer");
    //   this.$store.dispatch("drawer/setGraphic", null);
    // },
    showGysj(data) {
      console.log("showGysj", data);
      let id =
        data.type == "果园" ? window.gysjData.gyId : window.gysjData.jgId;
      this.gyName =
        data.type == "果园" ? window.gysjData.gyName : window.gysjData.jyName;
      getGysjData(id).then((res) => {
        console.log("getGysjData", res);
        this.gyDesc = res && res.detail ? res.detail : "";
        this.showdialog = true;
      });
    },
  },
  destroyed() {
    // this.chart.dispose();
  },
};
</script>

<style lang="stylus" scoped>
.detail-info
    max-height 500px
    padding 0 16px
    overflow-y auto
    &::-webkit-scrollbar
      width 4px
      background-color #030814
    /* 定义滚动条轨道 内阴影+圆角 */
    &::-webkit-scrollbar-track
      -webkit-box-shadow inset 0 0 6px transparent
      background-color transparent
    /* 定义滑块 内阴影+圆角 */
    &::-webkit-scrollbar-thumb
      border-radius 10px
      -webkit-box-shadow inset 0 0 6px transparent
      background-color #377DC0
    /* 定义最上方和最下方的按钮 */
    &::-webkit-scrollbar-button
      height 0
.panelContent
    height calc(100% - 43px)
    color #fff
    .tab-box
        position absolute
        top 40px
        right 2%
        z-index 999
        .tab-item
            color #fff
            font-size 10px
            padding-left 13px
            margin-right 20px
            position relative
            cursor pointer
            &:before
                content ' '
                width 12px
                height 12px
                border-radius 50%
                background #fff
                position absolute
                left 0
                top 50%
                transform translateY(-50%)
        .tab-item.active
            color #0e9cff
            &:before
                background #0e9cff
    .tableTitle
        background transparent
        color #fff
        padding 0
        font-size 13px
        text-align center
        justify-content center

    .tableBody
        height calc(100% - 24px)
        overflow hidden
        font-size 12px

        .scroll-content
            position relative
        .content1
            padding 0px 5px
            line-height 40px
            height 40px
            color #fff
            cursor pointer
            text-align center
        .money-num
            font-size 14px
            color #FCDC00
        .sale-num
            font-size 14px
            color #02c8f4

        .content1:nth-child(2n+1)
            line-height 40px
            background #003c5e
.videobox
  height calc(100% - 8px)
  margin-bottom 8px
  width calc(100% - 0px)
  border-radius 10px
.cardContentT
  height 33%
  .chart
    height calc(100% - 38px)
.cardContentG
  height 50%
.cardContent1
  height 33%
  position relative
  .chart
    height calc(100% - 38px)
// .cardContent
//   height 35%
//   .chart
//     height calc(100% - 38px)
.cardContents
  height 34%
  position relative
  .chart
    height calc(100% - 38px)
.tab-box
  position absolute
  top 40px
  right 2%
  z-index 999
  .tab-item
    color #fff
    font-size 10px
    padding-left 13px
    margin-right 20px
    position relative
    cursor pointer
    &:before
      content ' '
      // width 6px
      // height 6px
      width 12px
      height 12px
      border-radius 50%
      background #fff
      position absolute
      left 0
      top 50%
      transform translateY(-50%)
  .active
    color #0e9cff
    &:before
      background #0e9cff
.panel
  height calc(100% - 8px)
  width 100%
  font-size 0.06rem
  position relative
.closeDraw
  position absolute
  right 10px
  top 10px
  .el-button
    background transparent
    color #fff
    font-size 25px
    padding 0
    border 0
    position relative
.imgs
  height calc(100% - 38px)
  width calc(100% - 20px)
  padding 0 10px
  text-align center
  justify-content center
  >img
    width 100%
    height 100%
@media (max-width 1280px)
  .content
    height calc(100% - 25px)
  .imgs
    height calc(100% - 25px)
  .closeDraw
    top 5px
    .el-button
      font-size 15px
  .cardContentT
    height 24%
    .chart
      height calc(100% - 25px)
  .cardContent1
    height 19%
    .chart
      height calc(100% - 25px)
  .cardContent
    height 30%
    .chart
      height calc(100% - 25px)
  .cardContents
    height 27%
    .chart
      height calc(100% - 25px)
</style>
<style>
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 100% !important;
  padding-top: 0 !important;
  width: 100% !important;
}
.vjs-tech {
  width: 100% !important;
  height: 100% !important;
}
.vjs-poster {
  background-position: center !important;
  background-size: cover !important;
}
.dddd {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: fill;
  border: 1px #31d5f3 solid;
}
video {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  border: 1px #31d5f3 solid;
}
/* video{
      width: 100% !important;
      height: calc(100vh - 95px) !important;
      object-fit:fill;    //消除留白
} */
</style>
<style scoped>
.article-box ::v-deep p {
  text-indent: 2em;
}
.article-box ::v-deep p:has(img),
.article-box ::v-deep p:has(video) {
  text-indent: 0;
}
.article-box ::v-deep img,
.article-box ::v-deep video,
.article-box ::v-deep .el-image {
  width: 100% !important;
}
</style>
